import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DgxCommonModule } from '@domgen/dgx-fe-common';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { SharedUiDynamicFormBuilderModule } from '@domgen/dgx-fe-dynamic-form-builder';
import { DgxFormsAddressModule } from '@domgen/dgx-fe-forms/address';
import { DgxFormsCheckboxModule } from '@domgen/dgx-fe-forms/checkbox';
import { DgxFormsRadioModule } from '@domgen/dgx-fe-forms/radio';
import { DgxGAModule } from '@domgen/dgx-fe-ga';
import { DgxI18nModule } from '@domgen/dgx-fe-i18n';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProductDetailsModule } from '@product-details/product.details.module';
import { SharedModule } from '@shared/shared.module';
import { AdditionalServicesModule } from './../additional-services/additional.services.module';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import * as fromDirectives from './directives';
import { CompleteOrderEffects } from './store';
import { COMPLETE_ORDER_FEATURE, completeOrderReducers } from './store/reducers/index';

@NgModule({
  declarations: [
    ...fromComponents.components,
    ...fromContainers.containers,
    ...fromDirectives.directives,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ProductDetailsModule,
    AdditionalServicesModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(COMPLETE_ORDER_FEATURE, completeOrderReducers),
    EffectsModule.forFeature(CompleteOrderEffects),
    SharedUiDynamicFormBuilderModule,
    DgxQmModule.forRoot(),
    DgxCommonModule,
    DgxFormsAddressModule,
    DgxFormsCheckboxModule,
    DgxI18nModule.forRoot(),
    DgxGAModule,
    DgxFormsRadioModule,
    DgxComponentsButtonModule,
    RouterModule,
    DgxComponentsIconModule,
  ],
  exports: [
    ...fromComponents.components,
    ...fromContainers.containers,
    ...fromDirectives.directives,
  ],
})
export class CompleteOrderModule {}
